/**
 * Statusy paka (GdnPack) — etykiety i klasy etykiet (`label--${color}`), zgodne z modelem Rails.
 * @see app/models/gdn_pack.rb enum status
 */
const getGdnPackStatusLabelData = ({ status }) => {
  switch (status) {
    case "new":
      return { status_text: "Nowe", color: "default" };
    case "picking":
      return { status_text: "W kompletacji", color: "purple" };
    case "picked":
      return { status_text: "Skompletowane", color: "info-light" };
    case "packing":
      return { status_text: "Pakowane", color: "warning" };
    case "returning":
      return { status_text: "W zwrocie", color: "warning" };
    case "completed":
      return { status_text: "Zakończony", color: "success" };
    case "error":
      return { status_text: "Błąd", color: "danger" };
    case "completed_with_missings":
      return {
        status_text: "Wstrzymane z brakami",
        color: "danger",
      };
    case "need_verification":
      return { status_text: "Wymaga kontroli", color: "warning" };
    case "packed":
      return { status_text: "Spakowane", color: "success" };
    default:
      return { status_text: "Brak", color: "default" };
  }
};

export default getGdnPackStatusLabelData;
